import React from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm, getFormValues } from 'redux-form'
import { Button } from 'semantic-ui-react'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { scrollToFirstValidateFailElement } from 'core/utilities'
import { validations, validateCase as vCase } from 'core/validate'
import { AddDummyUserContainer } from './styled'
import { addDummyUser } from 'ducks/support'

// import r from 'reactotron-react-js'

const AddDummyUser = (props) => {
  const { reset, addDummyUser, valueForm } = props

  return (
    <AddDummyUserContainer>
      <form>
        <div className='rowFields'>
          <Field 
            name='vendorCode' 
            label='Vendor Code' 
            type={type.text}
            component={FieldInput} />
        </div>
        <div className='btnContainer'>
          <Button
            type='button'
            content='Submit'
            color='blue'
            icon='paper plane outline'
            labelPosition='right'
            style={{ marginRight: '5px' }}
            onClick={() => addDummyUser(valueForm, reset)}
          />
        </div>
      </form>
    </AddDummyUserContainer>
  )
}

const mapStateToProps = (state) => {
  return ({
    user: state.authen.user,
    valueForm: getFormValues('addDummyUserForm')(state) || {},
    initialValues: {
      vendorCode: ''
    }
  })
}

const mapDispatchToProps = {
  addDummyUser
}

const validate = (values) => {
  let errors = {}
  validations(values, 'vendorCode', [vCase.require], errors)

  return errors
}

const AddDummyUserForm = reduxForm({
  form: 'addDummyUserForm',
  enableReinitialize: true,
  onSubmitFail: scrollToFirstValidateFailElement,
  validate,
})(AddDummyUser)

export default connect(mapStateToProps, mapDispatchToProps)(AddDummyUserForm)